import types from "../types";
import buildRSA from "./buildRSA";
import queryString from "query-string";

export const getPromoCodes = (query = {}, previousData = []) => {
  const _query = queryString.stringify(query);
  return buildRSA(
    {
      endpoint: `/promo-codes?${_query}`,
      method: "GET",
      types: [
        types.DO_GET_PROMO_CODES,
        types.SET_GET_PROMO_CODES_DATA,
        types.SET_GET_PROMO_CODES_ERROR
      ]
    },
    true,
    false,
    json => {
      json.data = previousData.concat(json.data);
      return json;
    }
  );
};

export const updatePromoCode = (roleId, data) =>
  buildRSA(
    {
      endpoint: `/promo-codes/${roleId}`,
      method: "PATCH",
      types: [
        types.DO_PATCH_PROMO_CODE,
        types.SET_PATCH_PROMO_CODE_DATA,
        types.SET_PATCH_PROMO_CODE_ERROR
      ],
      body: data
    },
    true,
    false
  );

export const deletePromoCode = roleId =>
  buildRSA(
    {
      endpoint: `/promo-codes/${roleId}`,
      method: "DELETE",
      types: [
        types.DO_DELETE_PROMO_CODE,
        types.SET_DELETE_PROMO_CODE_DATA,
        types.SET_DELETE_PROMO_CODE_ERROR
      ]
    },
    true,
    false
  );

export const addPromoCode = data =>
  buildRSA(
    {
      endpoint: `/promo-codes`,
      method: "POST",
      types: [
        types.DO_POST_PROMO_CODE,
        types.SET_POST_PROMO_CODE_DATA,
        types.SET_POST_PROMO_CODE_ERROR
      ],
      body: data
    },
    true,
    false
  );

export default {
  getPromoCodes,
  updatePromoCode,
  deletePromoCode,
  addPromoCode
};
